import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

import './normalize.css';
import './bootstrap5.css';
import './quoter.css';
import './toast.css';
import './tailwindcss.css';

let intervalId;

console.log(
  `%c

█████   ██████  ███████ ███    ██ ████████      ██████  ██    ██  ██████  ████████ ███████     ██ ███    ██  ██████ 
██   ██ ██       ██      ████   ██    ██        ██    ██ ██    ██ ██    ██    ██    ██          ██ ████   ██ ██      
███████ ██   ███ █████   ██ ██  ██    ██        ██    ██ ██    ██ ██    ██    ██    █████       ██ ██ ██  ██ ██      
██   ██ ██    ██ ██      ██  ██ ██    ██        ██ ▄▄ ██ ██    ██ ██    ██    ██    ██          ██ ██  ██ ██ ██      
██   ██  ██████  ███████ ██   ████    ██         ██████   ██████   ██████     ██    ███████     ██ ██   ████  ██████ 
                                                  ▀▀                                                               

`,
  `font-family: monospace`
);

intervalId = setInterval(() => {
  console.log('checking #quoter-app...');
  const root = document.getElementById('quoter-app');

  if (root) {
    console.log('quoter-app found!');
    console.log(root.dataset);
    const app = root.dataset;
    ReactDOM.createRoot(root).render(<App app={app} />);
    clearInterval(intervalId);
  }
}, 500);
